import { Heading } from 'lucide-react';
import { z } from 'zod';
import { HeadingField } from '../renderers/fields/presentation/presentation-fields';
import type { FieldDefinition, HeadingFieldSchema } from '../types';

export const HeadingDefinition: FieldDefinition<HeadingFieldSchema, void> = {
  type: 'heading',
  toolboxLabel: 'Section Heading',
  category: 'Presentation',
  description: 'A large, structural title to break up long forms.',
  isPresentational: true,
  icon: Heading,

  createDefault: (id) => ({
    id,
    type: 'heading',
    name: `heading_${id}`,
    label: 'New Section',
    isPresentational: true,
    level: 2,
  }),

  configSchema: [
    { id: 'label', type: 'text', name: 'label', label: 'Heading Text', required: true },
    {
      id: 'level',
      type: 'number',
      name: 'level',
      label: 'Heading Level (1-6)',
      required: false,
      min: 1,
      max: 6,
    },
  ],

  buildValidation: () => z.any(), // Presentational fields don't validate data

  editComponent: HeadingField,
  viewComponent: HeadingField,
};
